import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["src", "poster"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "login-stage" }
const _hoisted_5 = {
  ref: "viewportRef",
  class: "login-stage__viewport"
}
const _hoisted_6 = {
  ref: "contentRef",
  class: "login-stage__content"
}
const _hoisted_7 = { class: "hero-visual" }
const _hoisted_8 = { class: "progress-grid" }
const _hoisted_9 = { class: "progress-core" }
const _hoisted_10 = { class: "auth-block" }
const _hoisted_11 = { class: "auth-field-wrap" }
const _hoisted_12 = ["value", "type", "disabled"]
const _hoisted_13 = ["aria-label"]
const _hoisted_14 = {
  key: 0,
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_15 = {
  key: 1,
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_16 = { class: "action-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AiContinuousGlobe = _resolveComponent("AiContinuousGlobe")!
  const _component_AiLoginBackdrop = _resolveComponent("AiLoginBackdrop")!
  const _component_AiHologramBrain = _resolveComponent("AiHologramBrain")!
  const _component_AiModuleList = _resolveComponent("AiModuleList")!
  const _component_AiProgressRing = _resolveComponent("AiProgressRing")!
  const _component_AiGradientButton = _resolveComponent("AiGradientButton")!
  const _component_AiHudCard = _resolveComponent("AiHudCard")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ai-login-page", {
      'ai-login-page--landscape': _ctx.layoutMode === 'landscape',
      'ai-login-page--portrait': _ctx.layoutMode === 'portrait',
      'ai-login-page--leaving': _ctx.isLeaving,
    }]),
    style: _normalizeStyle(_ctx.backgroundStyle)
  }, [
    _createElementVNode("video", {
      ref: "introVideoRef",
      class: _normalizeClass(["login-background-video", {
        'login-background-video--visible': _ctx.visibleBackgroundLayer === 'intro',
      }]),
      src: _ctx.loginBgIntroSrc,
      poster: _ctx.loginBgPosterSrc,
      autoplay: "",
      muted: "",
      playsinline: "",
      preload: "auto",
      "aria-hidden": "true",
      onEnded: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleBackgroundIntroEnded && _ctx.handleBackgroundIntroEnded(...args)))
    }, null, 42, _hoisted_1),
    _createElementVNode("video", {
      ref: "loopPrimaryVideoRef",
      class: _normalizeClass(["login-background-video", {
        'login-background-video--visible':
          _ctx.visibleBackgroundLayer === 'loop-primary',
      }]),
      src: _ctx.loginBgLoopSrc,
      muted: "",
      playsinline: "",
      preload: "auto",
      "aria-hidden": "true",
      onTimeupdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleLoopTimeUpdate('loop-primary'))),
      onEnded: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleLoopEnded('loop-primary')))
    }, null, 42, _hoisted_2),
    _createElementVNode("video", {
      ref: "loopSecondaryVideoRef",
      class: _normalizeClass(["login-background-video", {
        'login-background-video--visible':
          _ctx.visibleBackgroundLayer === 'loop-secondary',
      }]),
      src: _ctx.loginBgLoopSrc,
      muted: "",
      playsinline: "",
      preload: "auto",
      "aria-hidden": "true",
      onTimeupdate: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleLoopTimeUpdate('loop-secondary'))),
      onEnded: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleLoopEnded('loop-secondary')))
    }, null, 42, _hoisted_3),
    _createVNode(_component_AiContinuousGlobe, {
      active: _ctx.visibleBackgroundLayer !== 'intro'
    }, null, 8, ["active"]),
    _createVNode(_component_AiLoginBackdrop),
    _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"ambient-light\" aria-hidden=\"true\" data-v-72b412d3><span class=\"ambient-light__ray ambient-light__ray--one\" data-v-72b412d3></span><span class=\"ambient-light__ray ambient-light__ray--two\" data-v-72b412d3></span><span class=\"ambient-light__ray ambient-light__ray--three\" data-v-72b412d3></span><span class=\"ambient-light__ray ambient-light__ray--four\" data-v-72b412d3></span><span class=\"ambient-light__particle ambient-light__particle--one\" data-v-72b412d3></span><span class=\"ambient-light__particle ambient-light__particle--two\" data-v-72b412d3></span><span class=\"ambient-light__particle ambient-light__particle--three\" data-v-72b412d3></span><span class=\"ambient-light__particle ambient-light__particle--four\" data-v-72b412d3></span><span class=\"ambient-light__particle ambient-light__particle--five\" data-v-72b412d3></span><span class=\"ambient-light__particle ambient-light__particle--six\" data-v-72b412d3></span><span class=\"ambient-light__particle ambient-light__particle--seven\" data-v-72b412d3></span><span class=\"ambient-light__particle ambient-light__particle--eight\" data-v-72b412d3></span><span class=\"ambient-light__particle ambient-light__particle--nine\" data-v-72b412d3></span><span class=\"ambient-light__particle ambient-light__particle--ten\" data-v-72b412d3></span></div><div class=\"circuit-flow\" aria-hidden=\"true\" data-v-72b412d3><span class=\"circuit-flow__trace circuit-flow__trace--one\" data-v-72b412d3></span><span class=\"circuit-flow__trace circuit-flow__trace--two\" data-v-72b412d3></span><span class=\"circuit-flow__trace circuit-flow__trace--three\" data-v-72b412d3></span><span class=\"circuit-flow__trace circuit-flow__trace--four\" data-v-72b412d3></span><span class=\"circuit-flow__trace circuit-flow__trace--five\" data-v-72b412d3></span><span class=\"circuit-flow__trace circuit-flow__trace--six\" data-v-72b412d3></span><span class=\"circuit-flow__node circuit-flow__node--one\" data-v-72b412d3></span><span class=\"circuit-flow__node circuit-flow__node--two\" data-v-72b412d3></span><span class=\"circuit-flow__node circuit-flow__node--three\" data-v-72b412d3></span></div>", 2)),
    _createElementVNode("main", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(["login-stage__shell", {
            'login-stage__shell--portrait': _ctx.layoutMode === 'portrait',
            'login-stage__shell--landscape': _ctx.layoutMode === 'landscape',
          }]),
          style: _normalizeStyle({
            width:
              _ctx.layoutMode === 'scaled'
                ? `${_ctx.scaledBounds.width}px`
                : `${_ctx.naturalShellWidth}px`,
            height: _ctx.cardScale < 1 ? `${_ctx.scaledBounds.height}px` : 'auto',
          })
        }, [
          _createElementVNode("div", {
            class: "login-stage__scale",
            style: _normalizeStyle({
              transform:
                _ctx.cardScale < 1
                  ? `translateY(${_ctx.visualOffsetY}px) scale(${_ctx.cardScale})`
                  : `translateY(${_ctx.visualOffsetY}px)`,
            })
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_AiHudCard, null, {
                meta: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("div", { class: "hero-meta" }, [
                    _createElementVNode("div", { class: "meta-copy" }, [
                      _createElementVNode("span", null, "VOICE AI"),
                      _createElementVNode("small", null, "智能 · 语言 · 未来")
                    ]),
                    _createElementVNode("div", { class: "meta-copy meta-copy--right" }, [
                      _createElementVNode("span", null, [
                        _createTextVNode("INTELLIGENCE"),
                        _createElementVNode("br"),
                        _createTextVNode("EDUCATION")
                      ]),
                      _createElementVNode("div", { class: "meta-dots" }, [
                        _createElementVNode("i"),
                        _createElementVNode("i"),
                        _createElementVNode("i"),
                        _createElementVNode("i")
                      ])
                    ])
                  ], -1)
                ]))]),
                default: _withCtx(() => [
                  _createElementVNode("section", _hoisted_7, [
                    _createVNode(_component_AiHologramBrain)
                  ]),
                  _cache[15] || (_cache[15] = _createElementVNode("section", { class: "hero-title" }, [
                    _createElementVNode("h1", null, [
                      _createTextVNode("AI 智慧教育"),
                      _createElementVNode("br"),
                      _createTextVNode("知识库问答系统")
                    ]),
                    _createElementVNode("p", null, "实践教学平台")
                  ], -1)),
                  _createElementVNode("section", {
                    class: _normalizeClass(["status-banner", `status-banner--${_ctx.verificationState}`])
                  }, [
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "status-badge" }, null, -1)),
                    _createElementVNode("div", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.verificationTitle), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.verificationDetail), 1)
                    ])
                  ], 2),
                  _createElementVNode("section", _hoisted_8, [
                    _createVNode(_component_AiModuleList, {
                      items: _ctx.leftModules,
                      align: "left"
                    }, null, 8, ["items"]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_AiProgressRing, {
                        progress: _ctx.progress,
                        caption: _ctx.progressCaption,
                        state: _ctx.verificationState
                      }, null, 8, ["progress", "caption", "state"])
                    ]),
                    _createVNode(_component_AiModuleList, {
                      items: _ctx.rightModules,
                      align: "right"
                    }, null, 8, ["items"])
                  ]),
                  _createElementVNode("section", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "auth-icon" }, [
                        _createElementVNode("svg", {
                          viewBox: "0 0 24 24",
                          "aria-hidden": "true"
                        }, [
                          _createElementVNode("path", { d: "M12 1.75a5.25 5.25 0 0 0-5.25 5.25v2.75A3.25 3.25 0 0 0 3.5 13v6.5A3.25 3.25 0 0 0 6.75 22.75h10.5A3.25 3.25 0 0 0 20.5 19.5V13a3.25 3.25 0 0 0-3.25-3.25V7A5.25 5.25 0 0 0 12 1.75Zm-2.25 8V7a2.25 2.25 0 0 1 4.5 0v2.75h-4.5Z" })
                        ])
                      ], -1)),
                      _createElementVNode("input", {
                        value: _ctx.authorizationCode,
                        type: _ctx.showPassword ? 'text' : 'password',
                        class: "auth-input",
                        placeholder: "",
                        disabled: _ctx.isSubmitting,
                        onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                        onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('submit')), ["prevent"]), ["enter"]))
                      }, null, 40, _hoisted_12),
                      _createElementVNode("button", {
                        type: "button",
                        class: "auth-visibility",
                        "aria-label": _ctx.showPassword ? '隐藏授权码' : '查看授权码',
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.togglePasswordVisibility && _ctx.togglePasswordVisibility(...args)))
                      }, [
                        (!_ctx.showPassword)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_14, [...(_cache[11] || (_cache[11] = [
                              _createElementVNode("path", { d: "M12 5.25c-4.55 0-8.28 2.63-10.1 6.34a.92.92 0 0 0 0 .82c1.82 3.71 5.55 6.34 10.1 6.34s8.28-2.63 10.1-6.34a.92.92 0 0 0 0-.82C20.28 7.88 16.55 5.25 12 5.25Zm0 10.25a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" }, null, -1)
                            ]))]))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_15, [...(_cache[12] || (_cache[12] = [
                              _createElementVNode("path", { d: "M3.28 2.22a.75.75 0 0 0-1.06 1.06l3.1 3.1A11.66 11.66 0 0 0 1.9 11.59a.92.92 0 0 0 0 .82c1.82 3.71 5.55 6.34 10.1 6.34 1.8 0 3.47-.41 4.93-1.14l3.79 3.79a.75.75 0 1 0 1.06-1.06L3.28 2.22Zm8.72 13.28a3.5 3.5 0 0 1-3.5-3.5c0-.45.09-.89.25-1.28l4.53 4.53c-.39.16-.83.25-1.28.25Zm0-10.25c4.55 0 8.28 2.63 10.1 6.34a.92.92 0 0 1 0 .82 12.01 12.01 0 0 1-2.42 3.24l-3.04-3.04A4.75 4.75 0 0 0 10.1 6.07l-1.8-1.8c1.15-.65 2.4-1.02 3.7-1.02Z" }, null, -1)
                            ]))]))
                      ], 8, _hoisted_13),
                      _createElementVNode("div", {
                        class: _normalizeClass(["auth-state", `auth-state--${_ctx.verificationState}`])
                      }, [
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "auth-state__dot" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_ctx.verificationStateLabel), 1)
                      ], 2)
                    ])
                  ]),
                  _createElementVNode("section", _hoisted_16, [
                    _createVNode(_component_AiGradientButton, {
                      label: _ctx.buttonLabel,
                      hint: _ctx.buttonHint,
                      loading: _ctx.isSubmitting,
                      state: _ctx.verificationState,
                      "ripple-key": _ctx.buttonRippleId,
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('submit')))
                    }, null, 8, ["label", "hint", "loading", "state", "ripple-key"])
                  ]),
                  _cache[16] || (_cache[16] = _createElementVNode("footer", { class: "hero-footer" }, [
                    _createElementVNode("span", { class: "hero-footer__wave" }),
                    _createElementVNode("span", null, "智能语言交互 · 让学习更高效"),
                    _createElementVNode("span", { class: "hero-footer__line" })
                  ], -1))
                ]),
                _: 1
              })
            ], 512)
          ], 4)
        ], 6)
      ], 512)
    ])
  ], 6))
}